package com.partejar.app.feature.convite.data.remote

import com.partejar.app.core.network.ApiConfig
import com.partejar.app.core.network.PublicLinkApiProtocol
import com.partejar.app.core.network.PublicLinkApiProtocolResolver
import com.partejar.app.feature.convite.data.ConviteAceiteDataSource
import com.partejar.app.feature.convite.data.ConviteAceiteDetails
import com.partejar.app.feature.convite.data.ConviteAceiteInput
import com.partejar.app.feature.convite.data.ConviteAceiteResult
import com.partejar.app.feature.convite.data.ConviteAcessoException
import com.partejar.app.feature.convite.data.ConviteIndisponivelException
import com.partejar.app.feature.convite.data.ConviteInvalidoException
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.get
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import kotlinx.coroutines.CancellationException

class ConviteAceiteRemoteDataSource(
    private val client: HttpClient,
    private val apiConfig: ApiConfig
) : ConviteAceiteDataSource {
    private val publicLinkProtocol = PublicLinkApiProtocolResolver(client, apiConfig)

    override suspend fun validate(token: String): ConviteAceiteDetails = request {
        val response = if (publicLinkProtocol.resolve() == PublicLinkApiProtocol.LEGACY) {
            client.get(apiConfig.endpoint("/convites/aceite/$token"))
        } else {
            client.post(apiConfig.endpoint("/convites/aceite/validate")) {
                contentType(ContentType.Application.Json)
                setBody(ValidarConviteDto(token))
            }
        }
        when (response.status) {
            HttpStatusCode.OK -> response.body<ConviteAceiteDetailsDto>().toModel()
            HttpStatusCode.NotFound, HttpStatusCode.BadRequest -> throw ConviteInvalidoException()
            else -> throw ConviteIndisponivelException()
        }
    }

    override suspend fun accept(token: String, input: ConviteAceiteInput?): ConviteAceiteResult = request {
        val response = if (publicLinkProtocol.resolve() == PublicLinkApiProtocol.LEGACY) {
            client.post(apiConfig.endpoint("/convites/aceite/$token")) {
                contentType(ContentType.Application.Json)
                setBody(input?.let { AceitarConviteLegadoDto(it.name.trim(), it.password) } ?: AceitarConviteLegadoDto())
            }
        } else {
            client.post(apiConfig.endpoint("/convites/aceite")) {
                contentType(ContentType.Application.Json)
                setBody(input?.let { AceitarConviteDto(token, it.name.trim(), it.password) } ?: AceitarConviteDto(token))
            }
        }
        when (response.status) {
            HttpStatusCode.OK -> response.body<AceitarConviteResponseDto>().let {
                ConviteAceiteResult(it.accessToken, it.refreshToken, it.workspaceId)
            }
            HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden -> throw ConviteAcessoException()
            HttpStatusCode.NotFound, HttpStatusCode.BadRequest -> throw ConviteInvalidoException()
            else -> throw ConviteIndisponivelException()
        }
    }

    private fun ConviteAceiteDetailsDto.toModel() = ConviteAceiteDetails(
        invitedName = nomeConvidado,
        email = email,
        workspaceName = workspaceNome,
        profileName = perfilNome,
        professionalCategory = categoriaProfissional,
        expiresAt = expiraEm,
        existingUser = usuarioExistente
    )

    private suspend fun <T> request(block: suspend () -> T): T = try {
        block()
    } catch (error: CancellationException) {
        throw error
    } catch (error: ConviteInvalidoException) {
        throw error
    } catch (error: ConviteAcessoException) {
        throw error
    } catch (error: Throwable) {
        throw ConviteIndisponivelException()
    }
}
